<template>
    <div class="custom-breadcrumb">
        <ul style="display: flex; align-items: center">
            <li>
                <div class="item" @click="chatMainMenu('/')">
                    {{ $t("message.home") }}
                </div>
            </li>
            <li>
                <div class="item integration" @click="go('/integrations')" v-if="doesRouteHasIntegrations">
                    {{ $t("message.integrations") }}
                </div>
            </li>
            <li v-if="paths" class="d-flex align-items-center" v-for="(item, index) in paths">
                <div
                    :key="'br-' + index"
                    class="item sec"
                    :colorize="'c-' + index"
                    @click="item.path === 'chat' ? chatMainMenu(item.path) : go(item.path)"
                >
                    {{ item.title }}
                </div>
            </li>
            <li v-if="showSubjects">
                <select id="departSelect" v-model="selectedSubjectModel">
                    <option value="null">{{ $t("message.allDepartments") }}</option>
                    <option v-for="subject in subjects" :key="subject._id" :value="subject._id">
                        {{ getSubjectName(subject) }}
                    </option>
                </select>
            </li>
            <li v-if="select" class="d-flex align-items-center">
                <slot></slot>
            </li>

            <li class="ml-auto">
                <div class="d-flex justify-content-between align-items-center">
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                            theme: isDarkMode ? 'light-border' : 'google',
                            popperOptions: {
                                modifiers: [
                                    {
                                        name: 'computeStyles',
                                        options: {
                                            adaptive: false,
                                        },
                                    },
                                ],
                            },
                        }"
                        :leftPercentTile="getChatbotSessionStatus().status"
                        :content="`<div class='left-align-tooltip'>${$t('message.maxSessionCount')}: ${(
                            features.totalSessionCount || 0
                        ).toLocaleString()}<br/>
    ${$t('message.usedSessionCount')}: ${(conversationStatistics.chatbotUsage || 0).toLocaleString()}
    (${getChatbotSessionStatus().used}%)</div>`"
                        class="chatbot-information-item"
                    >
                        <Chatbot />
                    </div>
                    <div
                        v-if="showTrialRemainDay && trialInfo.trial && settings && settings.plan"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                            theme: isDarkMode ? 'light-border' : 'google',
                        }"
                        :content="$t('billing.trialTimeInformation', { dayCount: trialInfo.remainingDays })"
                        class="item four mr-2"
                        style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            word-break: break-all;
                        "
                    >
                        <span class="text-info bold" @click="$router.push('/billing')">
                            {{ $t("billing.trialTimeInformationShort", { dayCount: trialInfo.remainingDays }) }}
                        </span>
                    </div>
                    <button
                        v-if="customerDomainsFetched && !isSiteIntegrated()"
                        @click.prevent="integrationInstruction"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                            theme: isDarkMode ? 'light-border' : 'google',
                        }"
                        :content="$t('message.notIntegratedDesc')"
                        class="actionButtonBreadcrumb"
                    >
                        <md-icon style="color: red">support</md-icon>
                        {{ $t("message.notIntegrated") }}
                    </button>
                </div>
            </li>
            <li v-if="largeHeader">
                <md-button
                    style="min-width: 20px; max-width: 25px"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    :content="socketConnected ? $t('message.connectServer') : $t('message.disconnectServer')"
                    class="actionButtonBreadcrumb m-0 w-100 act-btn"
                    @click="disconnectSocket"
                >
                    <div :class="{ blinkAnimation: !socketConnected }">
                        <md-icon
                            :style="{
                                color: socketConnected ? 'green' : 'red',
                            }"
                            >wifi
                        </md-icon>
                    </div>
                </md-button>
            </li>
            <li v-if="largeHeader && telegramBotEnabled">
                <md-button
                    style="min-width: 20px; max-width: 25px"
                    class="actionButtonBreadcrumb m-0 wp-btn"
                    @click="$router.push('/integrations')"
                >
                    <TelegramIcon
                        style="width: 20px; height: 20px"
                        :color="!telegramBotInfo.initialized ? 'gray' : telegramServiceIsHealthy ? 'green' : '#e24444'"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                            theme: isDarkMode ? 'light-border' : 'google',
                        }"
                        :content="
                            !telegramBotInfo.initialized
                                ? 'Telegram Bot Servisine Ulaşılıyor'
                                : telegramServiceIsHealthy
                                ? 'Telegram Bot Servisine Sağlıklı'
                                : 'Telegram Bot Servisinde Sorun Var'
                        "
                    />
                </md-button>
            </li>
            <li v-if="whatsappChannelExists">
                <ChannelsStatus />
            </li>
            <li v-if="igChannelExists">
                <IGChannelsStatus />
            </li>
            <li v-if="messengerChannelExists">
                <MessengerChannelStatusWidget />
            </li>
            <li v-if="channelSmsVisable">
                <ChannelStatusPostaCell />
            </li>

            <li v-if="largeHeader">
                <md-button
                    style="min-width: 20px; max-width: 25px"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    :content="offlineMode ? $t('message.liveChatOff') : $t('message.liveChatOn')"
                    class="actionButtonBreadcrumb m-0 act-btn"
                >
                    <md-icon :style="{ color: offlineMode ? 'red' : 'green' }">support_agent</md-icon>
                </md-button>
            </li>
            <li
                class="item four"
                v-tippy="{
                    followCursor: true,
                    placement: 'bottom-end',
                    theme: isDarkMode ? 'light-border' : 'google',
                }"
                v-if="$_.get(wallet, 'whatsapp.amount')"
                @click="$router.push('/settings/wallet')"
                :content="'Whatsapp Bakiyeniz: ' + seperateWithCommas(wallet.whatsapp.amount.toFixed(2)) + '₺'"
            >
                <span class="date">WP. Bakiye:</span>

                <MoneyFormatter :price="wallet.whatsapp.amount" className="time" />
            </li>
            <li v-if="largeHeader" class="item four">
                <span class="date">{{ $t("time.today") }}:</span><span class="time">{{ getToday() }}</span>
            </li>
        </ul>
        <HeaderRight v-if="!largeHeader" />
    </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
import Arrows from "../svg/Arrows";
import HeaderRight from "../HeaderRight";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import TelegramIcon from "../../views/Pages/Chatbot/pages/integrations/svg/TelegramIcon";
import ChannelsStatus from "./ChannelStatusWidget.vue";
import IGChannelsStatus from "./IGChannelStatusWidget.vue";
import ChannelStatusPostaCell from "./ChannelStatusPostaCell.vue";
import Chatbot from "../svg/stepper/Chatbot.vue";
import MoneyFormatter from "../MoneyFormatter.vue";
import MessengerChannelStatusWidget from "./MessengerChannelStatusWidget.vue";

library.add(faInstagram);
export default {
    name: "AppBreadCrumb",
    components: {
        MessengerChannelStatusWidget,
        Arrows,
        HeaderRight,
        TelegramIcon,
        ChannelsStatus,
        IGChannelsStatus,
        ChannelStatusPostaCell,
        Chatbot,
        MoneyFormatter,
    },
    data() {
        return {
            customerDomainsFetched: false,
            wpInterval: null,
            doesRouteHasIntegrations: false,
            channelsVisible: false,
            channelSmsVisable: false,
        };
    },
    props: {
        paths: {
            type: Array,
            required: false,
        },
        select: {
            type: Boolean,
            required: false,
        },
        showSubjects: {
            type: Boolean,
            required: false,
            default: false,
        },
        showTrialRemainDay: {
            type: Boolean,
            default: true,
        },
        showChatbotSession: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            channelsBusiness: (state) => state.channel.channels.filter((x) => x.type === "whatsapp-business-api"),
            channelsV2: (state) => state.channel.channels.filter((x) => x.type === "whatsapp-v2"),
            channelsV1: (state) =>
                state.channel.channels.filter((x) => x.type === "whatsapp-v1" || x.type === "whatsapp-qr"),
            whatsappChannelExists: (state) =>
                state.channel.channels.filter((x) =>
                    ["whatsapp-v1", "whatsapp-v2", "whatsapp-business-api"].includes(x.type)
                ).length > 0,
            igChannelExists: (state) => state.channel.channels.filter((x) => ["instagram"].includes(x.type)).length > 0,
            messengerChannelExists: (state) =>
                state.channel.channels.filter((x) => ["messenger"].includes(x.type)).length > 0,
            wpInfo: (state) => state.whatsapp.info,
            telegramBotInfo: (state) => state.telegrambot.info,
            largeHeader: (state) => state.app.largeHeader,
            settings: (state) => state.setting.settings,
            customerDomains: (state) => state.visitor.customerDomains,
            site: (state) => state.site.site,
            socketConnected: (state) => state.socketStatus.socket_connected,
            debugMode: (state) => state.app.debugMode,
            socket: (state) => state.socketStatus.current_socket,
            offlineMode: (state) => state.setting.offlineMode,
            activeConversation: (state) =>
                state.app.fakeMode ? state.chat.fakeActiveConversation : state.chat.activeConversation,
            selectedSubject: (state) => state.subject.selectedSubject,
            trialInfo: (state) => {
                const site = state.site.site;
                if (site) {
                    const { createdAt } = site;
                    const tookDays = Math.max(moment().diff(moment(createdAt, "YYYY-MM-DD"), "day"), 0);
                    const isTrial = tookDays < _.get(state.setting.settings, "plan.trialDays");
                    return {
                        trial: isTrial,
                        remainingDays: isTrial ? _.get(state.setting.settings, "plan.trialDays") - tookDays : 0,
                    };
                } else {
                    return { trial: false, remainingDays: 0 };
                }
            },
            wallet: (state) => state.wallet.wallet,
            channels: (state) => state.channel.channels.filter((x) => x.type === "sms-postacell"),
            features: (state) => state.site.features || {},
            conversationStatistics: (state) =>
                state.site.conversationStatistics.reduce(
                    (acc, usage) => {
                        acc.chatbotUsage += usage.chatbotUsage;
                        acc.whatsappCounter += usage.whatsappCounter;
                        acc.instagramCounter += usage.instagramCounter;
                        acc.telegramCounter += usage.telegramCounter;
                        acc.webCounter += usage.webCounter;
                        acc.whatsappBusinessCounter += usage.whatsappBusinessCounter;
                        return acc;
                    },
                    {
                        chatbotUsage: 0,
                        whatsappCounter: 0,
                        instagramCounter: 0,
                        telegramCounter: 0,
                        webCounter: 0,
                        whatsappBusinessCounter: 0,
                    }
                ),
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            subjects: "subject/getUserSubjects",
            telegramBotEnabled: "setting/telegramBotEnabled",
            telegramServiceIsHealthy: "telegrambot/isHealthy",
        }),
        selectedSubjectModel: {
            get() {
                return this.selectedSubject;
            },
            set(value) {
                this.updateSelectedSubject(value);
            },
        },
    },
    methods: {
        ...mapActions({
            getCustomerDomainsIfNeed: "visitor/getCustomerDomainsIfNeed",
            updateSelectedSubject: "subject/updateSelectedSubject",
            toggleLargeHeader: "app/toggleLargeHeader",
        }),
        seperateWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        integrationInstruction() {
            this.$router.push("install-code");
        },
        toggle() {
            this.toggleLargeHeader();
        },
        go(path) {
            if (path) {
                this.$router.push(path);
            }
        },
        getToday() {
            moment.locale(this.$i18n.locale);
            return moment().format("Do MMM");
        },
        chatMainMenu(path) {
            if (path) {
                this.$router.push(path);
                this.$emit("to-chat-main", path);
            }
        },
        disconnectSocket() {
            if (this.debugMode && this.socketConnected) {
                this.socket.disconnect();
            }
        },
        isSiteIntegrated() {
            return this.customerDomainsFetched && this.customerDomains.length;
        },
        getSubjectName(subject) {
            const validLangs = Object.keys(subject.languageContent);
            const lang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            return _.get(subject, `languageContent.${lang}.name`);
        },
        channelSmsAvailability() {
            if (this.channels.length > 0) {
                this.channelSmsVisable = true;
            }
        },
        getChatbotSessionStatus() {
            const leftPercentTile =
                (100 / this.features.totalSessionCount) *
                (this.features.totalSessionCount - this.conversationStatistics.chatbotUsage);
            const usedPercentTile = (100 / this.features.totalSessionCount) * this.conversationStatistics.chatbotUsage;
            return {
                status:
                    leftPercentTile > 70 ? "high" : leftPercentTile <= 70 && leftPercentTile > 30 ? "medium" : "low",
                left: leftPercentTile.toFixed(1),
                used: usedPercentTile.toFixed(1),
            };
        },
    },
    mounted() {
        this.channelSmsAvailability();
        this.getCustomerDomainsIfNeed().then((x) => {
            this.customerDomainsFetched = true;
        });
        const route = this.$route.path;
        const integrationPath = "/integrations/";
        if (route.includes(integrationPath)) {
            this.doesRouteHasIntegrations = true;
        }
        console.log("asdasdasd", {
            sasda: this.getChatbotSessionStatus(),
        });
    },
    beforeDestroy() {
        if (this.wpInterval) clearInterval(this.wpInterval);
    },
};
</script>

<style lang="scss">
.left-align-tooltip {
    text-align: left;
}
.actionButtonBreadcrumb {
    .md-button-content {
        display: flex !important;
    }
}

.ant-menu-submenu-arrow {
    position: unset !important;
}

.custom-breadcrumb {
    position: sticky;
    top: 0;
    z-index: 998;
    .chatbot-information-item {
        background-color: #fff4de;
        color: #ffa800 !important;
        font-family: Poppins;
        font-size: 12px;
        cursor: pointer;
        padding: 4px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
            width: 20px;
            height: 20px;
        }

        &[leftPercentTile="low"] {
            background-color: #ffdede;

            [data-name="supsis-chatbot-svg"] {
                fill: rgb(168, 40, 40) !important;
            }
        }

        &[leftPercentTile="medium"] {
            background-color: #dee6ff;

            [data-name="supsis-chatbot-svg"] {
                fill: rgb(0 164 255) !important;
            }
        }

        &[leftPercentTile="high"] {
            background-color: #deffe7;

            [data-name="supsis-chatbot-svg"] {
                fill: rgb(111, 200, 98) !important;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
#departSelect {
    border: none;
    background-color: #f3f6f9;
    padding: 3px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-family: Poppins;
    font-weight: bolder;
    color: #3699ff;
}

.new-theme {
    .blinkAnimation {
        i {
            animation: blinkAnim 1s infinite;
        }
    }

    @keyframes blinkAnim {
        from {
            color: #f90000;
            opacity: 0;
        }
        to {
            color: #ff0a0a;
            opacity: 1;
        }
    }

    .custom-breadcrumb {
        padding: 15px;
        background-color: #ffffff;
        height: 45px;
        display: flex;
        align-items: center;
        width: 100%;
        border-bottom: 1px solid var(--color-border-default);

        ul {
            list-style: none;
            display: flex;
            margin: 0;
            padding: 0;
            width: 100%;

            li {
                border-right: 1px solid #ebedf3;
                margin-right: 3px;
                padding-right: 3px;

                &:last-child {
                    border-right: none;
                }
            }
        }

        path {
            fill: red;
        }

        .item {
            background-color: #fff4de;
            color: #ffa800;
            font-family: Poppins;
            font-weight: bolder;
            font-size: 12px;
            cursor: pointer;
            padding: 3px 10px;
            border-radius: 6px;

            &.sec {
                &[colorize="c-0"] {
                    background-color: #c9f7f5;
                    color: #1bc5bd;
                }

                &[colorize="c-1"] {
                    background-color: #eec9f7;
                    color: #8a1bc5;
                }

                &[colorize="c-2"] {
                    background-color: #e2f7c9;
                    color: #c5bf1b;
                }
            }

            &.third {
                background-color: #f3f6f9;
                color: #3699ff;
            }

            &.four {
                background-color: #f3f6f9;

                span.date {
                    color: #b5b5c3;
                    font-family: Poppins;
                    font-weight: 500;
                    font-size: 13px;
                }

                span.time {
                    color: #3699ff !important;
                    font-family: Poppins;
                    font-weight: 600;
                    font-size: 13px;
                    padding-left: 10px;
                }
            }
        }

        .integration {
            background-color: #e5b8f4;
            color: #c147e9;
        }
    }
}

#arrows {
    cursor: pointer;
    transition: all 0.3s;
    transform: rotateZ(90deg);

    &.open {
        transform: rotateZ(270deg);
    }
}
</style>
